import request from '@/utils/request'

// 查询优惠券实例列表

export function listCoupon(query) {
  return request({
    url: '/coupon/couponentity/list',  // Update this path
    method: 'get',
    params: query
  })
}

// 查询优惠券实例详细
export function getCoupon(id) {
  return request({
    url: '/coupon/couponentity/' + id,
    method: 'get'
  })
}

// 查询优惠券实例详细 (公开接口，用于用户优惠券核销)
export function getPublicCoupon(id) {
  return request({
    url: '/coupon/couponentity/public/' + id,
    method: 'get'
  })
}

// 新增优惠券实例
export function addCoupon(data) {
  return request({
    url: '/coupon/couponentity',
    method: 'post',
    data: data
  })
}

// 修改优惠券实例
export function updateCoupon(data) {
  return request({
    url: '/coupon/couponentity',
    method: 'put',
    data: data
  })
}

// 删除优惠券实例
export function delCoupon(id) {
  return request({
    url: '/coupon/couponentity/' + id,
    method: 'delete'
  })
}

// Get distribution options
export function getDistributionOptions() {
  return request({
    url: '/coupon/distribution/options',
    method: 'get'
  });
}

// Get template options
export function getTemplateOptions() {
  return request({
    url: '/coupon/template/options',
    method: 'get'
  });
}

// 查询用户优惠券列表 (Get User Coupons)
export function getUserCoupons() {
  return request({
    url: '/coupon/couponentity/user/list',
    method: 'get',
    params: {
      userId: undefined
    }
  })
}

// 预览实例核销（计算停车优惠）
export function previewCouponRedemption(couponId, data) {
  return request({
    url: `/coupon/usage/${couponId}/preview`,
    method: 'post',
    data
  })
}

// 使用优惠券 (Use Coupon)
export function useCouponById(couponId, usageData = {}) {
  return request({
    url: `/coupon/usage/${couponId}`,
    method: 'post',
    data: usageData
  })
}

// 查询优惠券模板列表
export function getCouponTemplateById(templateId) {
  return request({
    url: `/coupon/template/${templateId}`,
    method: 'get'
  })
}